import { SidebarServiceModule } from '@b2b/common/services/sidebar';
import { TODO } from '@b2b/types/core';
import angular from 'angular';
import { TitleListDirectiveModule } from '../title-list/title-list.directive';

SidebarDirective.$inject = ['$timeout', 'SidebarService'];

function SidebarDirective($timeout, SidebarService) {
  SidebarController.$inject = [];

  function SidebarController() {
    var ctrl = this;

    ctrl.sidebar = SidebarService;
    ctrl.sidebar.init();
  }

  return {
    restrict: 'A',
    replace: true,
    transclude: true,
    templateUrl: 'common/directives/sidebar/sidebar.tpl.html',
    bindToController: {},
    controllerAs: '$ctrl',
    controller: SidebarController,
    link: function ($scope, $element, $attrs) {
      // Modified after controller runs
      $(window).bind('click', function (e: TODO) {
        if (!$(e.target).hasClass('sidebar') && !$(e.target).parents('.sidebar').length) {
          if (SidebarService.isShown) {
            $timeout(function () {
              SidebarService.hide();
            }, 0);
          }
        }
      });
    },
  };
}

export const SidebarDirectiveModule = angular
  .module('acme.common.directive.sidebar', [SidebarServiceModule, TitleListDirectiveModule])
  .directive('sidebar', SidebarDirective).name;
